import { Component, Prop, Vue } from 'vue-property-decorator';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import map from '@/types/map/type-map'
import arcgisLayer from '@/types/map/type-arcgis-layer';
import axios from 'axios';
import { API_URL } from '@/App.settings';

/** Gestion des données de la cartographie */
@Module({
	namespaced: true
})
class CartoMod extends VuexModule {
//#region Data
	public cartoSelectedNodesIds: string[] = [];

	/** Noeud à afficher sur la map */
	private nodeId: string = '';

	/** Liste des types d'objet sélectionnés */
	private objectTypeValues: any[] = [];

	private objectTypeOptions: object[] = [];
	
	private isVisible: boolean = false;

	public map: map = {
		arcgisSelector :'',
		basemapJSON : null,
		layersParametersJSON: null,
		selectedLayers: null,
		url :'',
		mapApi : null,
		centerX : 0.0,
		centerY: 0.0,
		zoom : 0
	}

	public mapIsInitialized: boolean = false;

	public existingLayers: any[] = [];
	//public selectedLayers: any[] = [];
	public arcgisLayers: arcgisLayer[] = [];
	public mapKey: number = 0;

	public arcgisFeatures: object[] = [];
	public isLoadingUnregistered: boolean = false;
	public arcgisUnregistered: object[] = [];
	public dcxUnregistered: object[] = [];
//#endregion Data

//#region Mutations
	/** Réinitialisation du store VueX */
	@Mutation
	private reset() {
		this.cartoSelectedNodesIds = [];
		this.nodeId = '';
		this.isVisible = false;
		this.map = {
			arcgisSelector :'',
			basemapJSON : null,
			layersParametersJSON: null,
			selectedLayers: null,
			url :'',
			mapApi : null,
			centerX : 0.0,
			centerY: 0.0,
			zoom : 0
		}
		this.mapIsInitialized = false;
		this.existingLayers = [];
		this.arcgisLayers = [];
		this.mapKey = 0;
		this.arcgisFeatures = [];
		this.isLoadingUnregistered = false;
		this.arcgisUnregistered = [];
		this.dcxUnregistered = [];
	}

	@Mutation
	private setObjectTypesValues(values: any[]) {
		this.objectTypeValues = values;
	}

	@Mutation
	private setObjectTypeOptions(values: []) {
		this.objectTypeOptions = values;
	}


	@Mutation
	private setMapIsInitialized() {
		Vue.set(this, 'mapIsInitialized', true)
	}

	@Action
	public SetMapIsInitialized() {
		this.context.commit('setMapIsInitialized');
	}

	// @Mutation
	// mapSelect(submitMap: map) {
	// 	Vue.set(this, 'map', submitMap)
	// }

	@Mutation
	setExistingLayers(layers: any[]) {
		Vue.set(this, 'existingLayers', layers)
	}

	@Mutation
	setMapKey() {
		Vue.set(this, 'mapKey', this.mapKey + 1)
	}

	@Mutation
	setSelectedLayers(layers: any[]) {
		Vue.set(this.map, 'selectedLayers', JSON.stringify(layers))
		//console.log(this.map.selectedLayers)
	}

	@Mutation
	setArcgisLayers(layers: object[]) {
		Vue.set(this, 'arcgisLayers', layers)
	}

	@Mutation
	cartoDeselectAllNodes() {
		this.cartoSelectedNodesIds = [];
	}

	@Mutation
	cartoDeselectNodeById(NodeId: string) {
		this.cartoSelectedNodesIds = this.cartoSelectedNodesIds.filter(e => e !== NodeId)
	}

	@Mutation
	cartoSelectNodeById(nodeId: string) {
		this.cartoSelectedNodesIds.push(nodeId);
	}

	@Mutation
	setArcgisData(invariants: object[]) {
		Vue.set(this, 'arcgisFeatures', invariants)
	}

	@Mutation
	setArcgisUnregistered(unregisteredFeatures: object[]) {
		Vue.set(this, 'arcgisUnregistered', unregisteredFeatures)
	}

	@Mutation
	setDcxUnregistered(unregisteredObjects: object[]) {
		Vue.set(this, 'dcxUnregistered', unregisteredObjects)
	}

	@Mutation
	setIsLoadingUnregistered(booleanSetter : boolean) {
		Vue.set(this, 'isLoadingUnregistered', booleanSetter)
	}

	@Mutation
	setLayersParametersJSON(layersJSON: string) {
		Vue.set(this.map, 'layersParametersJSON', layersJSON)
	}

	@Mutation
	setMapBasemap(basemap: object | string) {
		Vue.set(this.map, 'basemapJSON', basemap)
	}

	@Mutation
	private initMapSettings(settings) {
		this.map = JSON.parse(settings);
	}

	@Mutation
	private setNodeId(nodeId: string) {
		this.nodeId = nodeId;
	}

	@Mutation
	private setIsVisible (value: boolean) {
		this.isVisible = value;
	}
//#endregion Mutations
//#region Actions
	/** Réinitialisation du store VueX */
	@Action({ rawError: true })
	public Reset() {
		this.context.commit('reset');
	}

	/** Noeud à afficher sur la carte */
	@Action({ rawError: true })
	public SetNodeId(nodeId: string) {
		this.context.commit('setNodeId', nodeId);
	}

	/** Type d'objet à afficher sur la carte */
	@Action({ rawError: true })
	public SetObjectTypeValues(objectTypes: any[]) {
		this.context.commit('setObjectTypesValues', objectTypes);
	}

	@Action({ rawError: true })
	public SelectNode({ nodeId, objectType }) {
		let temp: any[] = JSON.parse(JSON.stringify(this.objectTypeValues));

		if (!temp.find(o =>  o['Index'] === objectType)) {
			let option = this.objectTypeOptions.find(o => o['Index'] === objectType);
			if (option)
				temp.push(option);
		}

		this.context.commit('setObjectTypesValues', temp);
		this.context.commit('setNodeId', nodeId);
	}

	@Action({ rawError: true })
	public async LoadObjectTypeOptions() {
		var data = {
			token: Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : ""
		};

		await axios.post(API_URL + "carto/getAllCartoElements", data).then((result) => {
			if (result && result.data)
				this.context.commit('setObjectTypeOptions', result.data);
		});
	}

	@Action({ rawError: true })
	public SetIsVisible (value: boolean) {
		this.context.commit('setIsVisible', value);
	}

	@Action({ rawError: true })
	public ToggleIsVisible () {
		this.context.commit('setIsVisible', !(this.isVisible));
	}

	/** Initialise les paramètres de la cartographie */
	@Action({ rawError: true })
	public async InitMapSettings() {
		var data = {
			token: Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : ""
		};

		await axios.post(API_URL + "carto/getMapWebSettings", data).then((result) => {
			if (result && result.data)
				this.context.commit('initMapSettings', result.data);

			console.debug(`CartoMod - InitMapSettings - map : ${JSON.stringify(this.map)}`)
			console.debug(`CartoMod - InitMapSettings - zoom type : ${typeof(this.map.zoom)}`)
		});
	}
//#endregion Actions
//#region Getters
	public get getMapKey(): number {
		return this.mapKey;
	}

	public get getArcgisUnregistered(): object[] {
		return this.arcgisUnregistered;
	}

	public get getMap(): map {
		return this.map;
	}

	public get getArcgisLayers(): arcgisLayer[] {
			return this.arcgisLayers;
	}

	public get GetNodeId(): string {
		return this.nodeId;
	}

	public get GetObjectTypes(): string[] {
		return this.objectTypeValues;
	}

	public get GetObjectTypeOptions(): object[] {
		return this.objectTypeOptions;
	}

	public get GetIsVisible(): boolean {
		return this.isVisible;
	}
//#endregion Getters
}

export default CartoMod;